'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadl';
var iconName = 'police-box';
var width = 384;
var height = 512;
var aliases = [];
var unicode = 'e021';
var svgPathData = ['M64 104l0 376 256 0 0-376c0-4.4-3.6-8-8-8l-8 0c-8.8 0-16-7.2-16-16l0-16-96 0L96 64l0 16c0 8.8-7.2 16-16 16l-8 0c-4.4 0-8 3.6-8 8zm24 40c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16l0-64zm0 128c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16l0-64zM200 144c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16l0-64z', 'M208 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 16L96 32C78.3 32 64 46.3 64 64l0 .8C45.7 68.5 32 84.6 32 104l0 376-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l352 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-376c0-19.4-13.7-35.5-32-39.2l0-.8c0-17.7-14.3-32-32-32l-80 0 0-16zm112 88l0 376L64 480l0-376c0-4.4 3.6-8 8-8l8 0c8.8 0 16-7.2 16-16l0-16 96 0 96 0 0 16c0 8.8 7.2 16 16 16l8 0c4.4 0 8 3.6 8 8zM112 328l0-48 48 0 0 48-48 0zM88 272l0 64c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-64 0c-8.8 0-16 7.2-16 16zm24-120l20 0 0 20-20 0 0-20zm28 0l20 0 0 20-20 0 0-20zm0 28l20 0 0 20-20 0 0-20zm-8 20l-20 0 0-20 20 0 0 20zm-28-72c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-64 0zm120 72l0-20 20 0 0 20-20 0zm28 0l0-20 20 0 0 20-20 0zm0-28l0-20 20 0 0 20-20 0zm-8-20l0 20-20 0 0-20 20 0zm-44-8l0 64c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-64 0c-8.8 0-16 7.2-16 16z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faPoliceBox = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;